import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface ConfirmSendSmsDialogProps {
  isOpen: boolean;
  onSubmit: () => void;
  onOpenChange: (open: boolean) => void;
}

export function ConfirmSendSmsDialog({
  isOpen,
  onSubmit,
  onOpenChange,
}: ConfirmSendSmsDialogProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are sure you want to send SMS?</AlertDialogTitle>
          <AlertDialogDescription>
            You are about to send an SMS message to the selected participants.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onSubmit}
            className="text-destructive border-destructive hover:text-destructive min-w-[150px]"
            data-testid="submit-button"
          >
            Send SMS
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
